/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useState, useEffect } from "react";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import DataGridButton from "../../components/DataGridButton";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useGetPrBuilds } from "../../api/pullRequests";
import RedirectLink from "../../components/RedirectLink";
import { githubUrl } from "../../utils/urls";
import { timeFormat } from "../../utils/constants";
import { dataGridButtonTypography } from "../../styles/DataGridStyles";
import { dataGridButtonStyles } from "../../styles/buttonStyles";
import { tabbedDataGridPage } from "../../styles/commonPageStyles";
import utilColors from "../../styles/utilColors";

const MergedPullRequestBuilds = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [prs, setPrs] = useState([]);

  const {
    postData: getPrs,
    response: getPrsResp,
    isLoading: isLoadingPrs,
  } = useGetPrBuilds();

  useEffect(() => {
    getPrs();
  }, []);

  useEffect(() => {
    if (Array.isArray(getPrsResp?.response)) {
      setPrs(getPrsResp.response);
    }
  }, [getPrsResp]);

  const columns = [
    {
      field: "repoName",
      renderHeader: () => <Typography variant="h5">Repository Name</Typography>,
      flex: 2.5,
      cellClassName: "name-column--cell",
      renderCell: ({ row: { repoName } }) => (
        <Typography variant="h5">{repoName || ""}</Typography>
      ),
    },
    {
      field: "commitMessage",
      flex: 4,
      renderHeader: () => <Typography variant="h5">PR Title</Typography>,
      renderCell: ({ row: { commitMessage } }) => (
        <Typography variant="h5">{commitMessage ?? ""}</Typography>
      ),
    },
    {
      field: "tag",
      flex: 1,
      renderHeader: () => <Typography variant="h5">Tag</Typography>,
      renderCell: ({ row: { commitHash, repoName, tag } }) => (
        <RedirectLink
          href={`${githubUrl}/${repoName}/commit/${commitHash}`}
          color={utilColors.skyBlue}
        >
          <Typography variant="h5">{tag ?? ""}</Typography>
        </RedirectLink>
      ),
    },
    {
      field: "baseBranch",
      flex: 1,
      renderHeader: () => <Typography variant="h5">Base</Typography>,
      renderCell: ({ row: { baseBranch } }) => (
        <Typography variant="h5">{baseBranch ?? ""}</Typography>
      ),
    },
    {
      field: "buildStatus",
      flex: 1.5,
      renderHeader: () => <Typography variant="h5">Status</Typography>,
      renderCell: ({ row: { buildStatus } }) => (
        <Typography variant="h5">{buildStatus ?? ""}</Typography>
      ),
    },
    {
      field: "createdAt",
      flex: 2,
      renderHeader: () => <Typography variant="h5">Created At</Typography>,
      renderCell: ({ row: { createdAt } }) => (
        <Typography variant="h5">
          {moment(createdAt).format(timeFormat)}
        </Typography>
      ),
    },
  ];

  return (
    <Box sx={tabbedDataGridPage.tabContentMainBox}>
      <Grid sx={tabbedDataGridPage.gridContainer} container columns={2}>
        <Grid xs={1}>
          <Header
            title="Merged Pull Request Builds"
            subtitle="See the list of non-successful builds of merged pull requests"
          />
        </Grid>
        <Grid xs={1}>
          <Box sx={tabbedDataGridPage.topButtonStack}>
            <DataGridButton
              sx={dataGridButtonStyles.pageTopButtons}
              onClick={() => getPrs()}
            >
              <Typography sx={dataGridButtonTypography(colors, 500)}>
                RELOAD
              </Typography>
            </DataGridButton>
          </Box>
        </Grid>
      </Grid>
      <Box sx={tabbedDataGridPage.dataGridBoxStyles(colors)}>
        <DataGridPro
          disableSelectionOnClick
          getRowId={(row) => `${row?.repoName}/${row.commitHash}`}
          loading={isLoadingPrs}
          rows={prs}
          columns={columns}
        />
      </Box>
    </Box>
  );
};

export default MergedPullRequestBuilds;
